import { render, staticRenderFns } from "./picList.vue?vue&type=template&id=368983e2&scoped=true&"
import script from "./picList.vue?vue&type=script&lang=js&"
export * from "./picList.vue?vue&type=script&lang=js&"
import style0 from "./picList.vue?vue&type=style&index=0&id=368983e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368983e2",
  null
  
)

export default component.exports